import { GetStaticProps, NextPage } from 'next'
import { initializeApollo } from '../../lib/apolloClient'
import globalCache from '../../lib/globalCache'
import JournalMain from '../../components/journal/JournalMain/JournalMain'
import {
  journalItems,
  journalItemsVariables,
} from '../../__generated__/journalItems'
import {
  JOURNAL_ITEMS,
  JOURNAL_YOUTUBE_ITEMS,
} from '../../queries/journalQuery'
import { HeaderColors } from '../../components/types'
import {
  journalYoutubeItems,
  journalYoutubeItemsVariables,
} from '../../__generated__/journalYoutubeItems'
import { SortOrder } from '../../__generated__/globalTypes'
import JournalProvider from '../../contexts/journalMainProvider'
import { getJournalYoutubeVariables } from '../../lib/gql'
import { getJournalSections } from '../../lib/getJournalSections'
import { createPageSeo, getPageSeo } from '../../lib/createPageSeo'

const JournalPage: NextPage<{ today: string }> = ({ today }) => {
  return (
    <JournalProvider today={today}>
      <JournalMain />
    </JournalProvider>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo()
  const today = new Date().toISOString()
  await globalCache(apolloClient)

  let seo

  const [seoData] = await Promise.all([
    getPageSeo(apolloClient, 'journal-main'),
    apolloClient.query<journalItems, journalItemsVariables>({
      query: JOURNAL_ITEMS,
      variables: {
        where: {
          iblock: { code: { equals: 'articles' } },
          active: { equals: true },
          OR: [
            {
              activeFrom: { lte: today },
              activeTo: { equals: null },
            },
            {
              activeFrom: { lte: today },
              activeTo: { gte: today },
            },
            {
              activeFrom: { equals: null },
              activeTo: { equals: null },
            },
            {
              activeFrom: { equals: null },
              activeTo: { gte: today },
            },
          ],
        },
        first: 9,
        order: { activeFrom: SortOrder.desc },
      },
    }),
    apolloClient.query<journalYoutubeItems, journalYoutubeItemsVariables>({
      query: JOURNAL_YOUTUBE_ITEMS,
      variables: getJournalYoutubeVariables(),
    }),
    getJournalSections(apolloClient),
  ])

  if (seoData?.data?.element) {
    seo = createPageSeo(seoData.data)
  }

  return {
    props: {
      __APOLLO_STATE__: apolloClient.cache.extract(),
      headerInitColor: HeaderColors.white,
      seo,
      today,
    },
    revalidate: 60,
  }
}
export default JournalPage
